export default (
	<svg width="14" height="14" fill="#ffffff" viewBox="0 2 16 16" className="Icon_icon__2tZrT Icon_normal__2Oune">
		<path
			d="M10.667 8.04V6.43C6.58 6.405 4 11.765 4 11.765s.012-8.028 6.68-9.333L10.671.919a.5.5 0 01.84-.368L16 4.725l-4.516 3.703a.5.5 0 01-.817-.387zm2.283 3.06c.579 0 1.05.471 1.05 1.05v1.54A2.313 2.313 0 0111.69 16H2.31A2.312 2.312 0 010 13.69V4.31A2.312 2.312 0 012.31 2h1.54c.579 0 1.05.471 1.05 1.05 0 .579-.471 1.05-1.05 1.05H2.31a.21.21 0 00-.21.21v9.38c0 .116.095.21.21.21h9.38a.21.21 0 00.21-.21v-1.54c0-.579.471-1.05 1.05-1.05z"
			fillRule="evenodd"
		></path>
	</svg>
);
